module.exports = __webpack_public_path__ + "static/about3-ea0411015634197eef2f835840b2f22c.jpg";